export const SET_CONVERSATIONS="app/conversations/SET_CONVERSATIONS"
